import type { ReceiptPaymentType } from 'src/api';
import { ReceiptPatientPaymentType, TimeOffType } from 'src/api';
import { receiptPatientPaymentTypeOptionsMapper } from 'src/utils/mappers';
import gettext from '../utils/gettext';

const { $gettext } = gettext;

export enum RichTextEditTemplateApplyType {
  ADD = 'add',
  REPLACE = 'replace',
}

export interface PaymentOption {
  value: ReceiptPatientPaymentType | ReceiptPaymentType;
  label: string;
  disable?: boolean;
}

export const receiptPatientPaymentTypeOptions: PaymentOption[] = [
  {
    label: receiptPatientPaymentTypeOptionsMapper(
      ReceiptPatientPaymentType.CASH
    ),
    value: ReceiptPatientPaymentType.CASH,
  },
  {
    label: receiptPatientPaymentTypeOptionsMapper(
      ReceiptPatientPaymentType.BANK_TRANSFER
    ),
    value: ReceiptPatientPaymentType.BANK_TRANSFER,
  },
  {
    label: receiptPatientPaymentTypeOptionsMapper(
      ReceiptPatientPaymentType.CARD
    ),
    value: ReceiptPatientPaymentType.CARD,
  },
];
export const onlineReservationRequiredPaymentTypeOptions: PaymentOption[] = [
  {
    label: $gettext('Kartou online'),
    value: ReceiptPatientPaymentType.CARD,
  },
];
export const onlineReservationPaymentTypeOptions: PaymentOption[] = [
  {
    label: $gettext('V ordinaci hotově/kartou'),
    value: ReceiptPatientPaymentType.CASH,
  },
  ...onlineReservationRequiredPaymentTypeOptions,
];
export const onlineReservationTicketPaymentOptions: PaymentOption[] = [
  {
    label: $gettext('Zaplatit permanentkou'),
    value: ReceiptPatientPaymentType.TICKET,
  },
];

export const timeOffTypeOptions = [
  { value: TimeOffType.TIME_OFF, label: $gettext('Volno (Dovolená)') },
  {
    value: TimeOffType.EXTRA_OFFICE_HOURS,
    label: $gettext('Nepravidelné ordinační hodiny'),
  },
];

export enum PaymentStatusOptions {
  PAID = 'PAID',
  REJECTED = 'PENDING',
}

export { phonePrefixOptions } from 'src/utils/phonePrefixes';
